import type { Actions } from "@types";
import React from "react";

// Props
type ParserChildProps = {
  parse: (message: string) => void;
  actions: Actions;
};

type MessageParserProps = {
  children: React.ReactNode;
  actions: Actions;
};

const MessageParser: React.FC<MessageParserProps> = ({ children, actions }) => {
  const parse = (message: string) => {
    const text = message.trim();
    if (!text) return;

    void actions.searchKeyword(text);
  };

  return (
    <>
      {React.Children.map(children, (child) =>
        React.isValidElement(child)
          ? React.cloneElement(
              child as React.ReactElement<Partial<ParserChildProps>>,
              { parse, actions }
            )
          : child
      )}
    </>
  );
};

export default MessageParser;
